<section id="fonctionnalites" class="container-features">
  <h2>Fonctionnalités</h2>
  <swiper
    [navigation]="true"
    [pagination]="{ clickable: true }"
    [loop]="true"
    [effect]="'creative'"
    [speed]="450"
    [creativeEffect]="{
      prev: {
        shadow: true,
        translate: [0, 0, -400],
        opacity: 0
      },
      next: {
        translate: ['120%', 0, 0]
      }
    }"
    class="features-slider"
  >
    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Tableau de bord</h3>
          <p>
            Notre tableau de bord vous donne un aperçu en temps réel de vos
            documents RH, de vos collaborateurs et de vos contrats. Vous pouvez
            suivre les statistiques clés, telles que le nombre de documents en
            attente de signature et les renouvellements de contrat à venir.
          </p>
        </div>
        <div>
          <img
            src="assets/img/tableau_de_bord.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Gestion de modèles de documents</h3>
          <p>
            Créez des modèles de documents RH standard pour une utilisation
            répétitive. Vous pouvez ajouter des clauses de contrat pour
            personnaliser les modèles en fonction de vos besoins. Les modèles
            peuvent être utilisés pour la création de nouveaux documents, ce qui
            vous permet de gagner du temps et de l'efficacité.
          </p>
        </div>
        <div>
          <img
            src="assets/img/modele_de_document.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Création de procédures</h3>
          <p>
            Nous vous offrons la possibilité de créer des processus standardisés
            pour les processus RH. Ajoutez des étapes avec des documents
            associés et définissez les actions à mener par les différents
            collaborateurs. Cela vous permet de suivre et de gérer les processus
            RH de manière centralisée et efficace.
          </p>
        </div>
        <div>
          <img
            src="assets/img/procedure.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Gestion de plusieurs entités</h3>
          <p>
            Vous pouvez gérer plusieurs entreprises à partir d'une seule
            interface pour une meilleure efficacité. Cela vous permet de suivre
            les informations RH pour chaque entité et de prendre des décisions
            informées.
          </p>
        </div>
        <div>
          <img
            src="assets/img/gestion_entites.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Gestion de collaborateurs et de leurs contrats</h3>
          <p>
            Suivez les informations des collaborateurs et de leurs contrats de
            manière centralisée pour une meilleure organisation. Gardez un œil
            sur les renouvellements de contrat, les mises à jour de salaire et
            les informations de contact des collaborateurs.
          </p>
        </div>
        <div>
          <img
            src="assets/img/gestion_poste_et_contrats.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="card transparent-bg">
        <div class="slide-content">
          <h3>Paramétrage</h3>
          <p>
            Personnalisez la solution en fonction de vos besoins spécifiques en
            paramétrant les types de contrats, les types de documents, les
            formes sociales et les types de représentants légaux. Cela garantit
            que les informations sont correctement enregistrées et suivies.
          </p>
        </div>
        <div>
          <img
            src="assets/img/personnalisable.png"
            alt="Tableau de bord"
            class="slide-img"
          />
        </div>
      </div>
    </ng-template>
  </swiper>
</section>
